import useTranslator from "@pma/hooks/use-translator"
import { useState } from "react"
import { Box } from "lucide-react"
import { DictType } from "@pma/types"
import { Popover, PopoverContent, PopoverTrigger } from "../common/popover"
import { cn } from "@pma/utils/helpers"
import { Button } from "../common/button"

interface Props {
  workDiaryDetails: DictType
}

const WorkDiaryResources = ({ workDiaryDetails }: Props) => {
  const { translate, locale } = useTranslator()
  const isHebrew = locale == "he" ? true : false

  const [openLogs, setOpenLogs] = useState(false)

  const resourcesList = workDiaryDetails?._diary_resourses?.filter(
    (obj: any) => obj._resource?.structures,
  )
  const workFlowList = workDiaryDetails?._diary_resourses?.filter(
    (obj: any) => obj._resource?.employees,
  )
  const toolsList = workDiaryDetails?._diary_resourses?.filter((obj: any) => obj._resource?.tools)

  return (
    <Popover open={openLogs} onOpenChange={setOpenLogs}>
      <PopoverTrigger asChild className='cursor-pointer'>
        <div
          className={cn("flex w-full cursor-pointer items-center gap-0", isHebrew ? "rtl" : "ltr")}
          onMouseEnter={() => setOpenLogs(true)}
          onMouseLeave={() => setOpenLogs(false)}
        >
          <Button
            variant={"ghost"}
            className='m-0 p-0 hover:bg-transparent'
            leftSection={<Box size={16} className='mx-1 text-green-600' />}
          >
            {workDiaryDetails?._diary_resourses?.length > 0
              ? workDiaryDetails?._diary_resourses?.length
              : "-"}
          </Button>
        </div>
      </PopoverTrigger>
      <PopoverContent
        className={workDiaryDetails?._diary_resourses?.length ? "w-full md:w-[400px]" : "hidden"}
      >
        <div className='mb-5'>
          <h3 className='mb-3 border-b pb-2 text-lg font-bold'>{translate("Resources")}</h3>
          <ul className='list-inside list-disc space-y-1 pl-4'>
            {resourcesList.length ? (
              resourcesList.map((details: any, index: number) => (
                <li key={`r_${index}`} className='text-gray-800'>
                  <strong>
                    {locale == "he" ? details?._resource?.he : details?._resource?.en}:{" "}
                  </strong>
                  {details?.amount} {`(${details?.remarks})`}
                </li>
              ))
            ) : (
              <>{translate("No Record Found")}</>
            )}
          </ul>
        </div>
        <div className='mb-5'>
          <h3 className='mb-3 border-b pb-2 text-lg font-bold'>{translate("Workforce")}</h3>
          <ul className='list-inside list-disc space-y-1 pl-4'>
            {workFlowList?.length ? (
              workFlowList.map((details: any, index: number) => (
                <li key={`r_${index}`} className='text-gray-800'>
                  <strong>
                    {locale == "he" ? details?._resource?.he : details?._resource?.en}:{" "}
                  </strong>
                  {details?.amount} {`(${details?.remarks})`}
                </li>
              ))
            ) : (
              <>{translate("No Record Found")}</>
            )}
          </ul>
        </div>
        <div className='mb-5'>
          <h3 className='mb-3 border-b pb-2 text-lg font-bold'>{translate("Tools")}</h3>
          <ul className='list-inside list-disc space-y-1 pl-4'>
            {toolsList?.length ? (
              toolsList.map((details: any, index: number) => (
                <li key={`r_${index}`} className='text-gray-800'>
                  <strong>
                    {locale == "he" ? details?._resource?.he : details?._resource?.en}:{" "}
                  </strong>
                  {details?.amount} {`(${details?.remarks})`}
                </li>
              ))
            ) : (
              <>{translate("No Record Found")}</>
            )}
          </ul>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export default WorkDiaryResources
